import * as React from "react";
import { Box } from "../box";
import { cx, filterDOMProps } from "../../utils/dom";
import {
  AlignItemsType,
  FlexDirectionType,
  JustifyContentType,
  SizeOption,
} from "../../utils/theme";
import { BoxProps } from "../box/box";
import { AsProps, ResponsiveProp } from "../../utils/types";
import { breakpointClassNames } from "../../utils/helpers";

export interface FlexProps extends BoxProps {
  justify?: JustifyContentType;
  align?: AlignItemsType;
  direction?: FlexDirectionType;
  gap?: ResponsiveProp<SizeOption>;
  columnGap?: ResponsiveProp<SizeOption>;
  rowGap?: ResponsiveProp<SizeOption>;
  stack?: boolean;
  inline?: boolean;
  wrap?: "wrap" | "nowrap" | "wrap-reverse";
}

export const _Flex = <T extends React.ElementType = "div">(
  props: React.PropsWithChildren<FlexProps> & AsProps<T>,
  ref: React.Ref<T>
) => {
  const {
    justify,
    align,
    direction,
    gap = "sm",
    columnGap,
    rowGap,
    inline,
    wrap,
    stack,
    className,
    as,
    ...otherProps
  } = props;

  const flexDirection = stack ? "column" : direction ?? "row";

  return (
    <Box
      as={as}
      className={cx(
        className,
        inline ? "display-inline-flex" : "display-flex",
        `flex-direction-${flexDirection}`,
        wrap && `flex-${wrap}`,
        justify && `flex-justify-${justify}`,
        align && `flex-align-${align}`,
        breakpointClassNames("gap", gap),
        breakpointClassNames("column-gap", columnGap),
        breakpointClassNames("row-gap", rowGap)
      )}
      // TODO - Fix types here - seems to work just fine though
      ref={ref as any}
      {...(filterDOMProps(otherProps) as any)}
    >
      {props.children}
    </Box>
  );
};

_Flex.displayName = "Flex";

export const Flex = React.forwardRef(_Flex) as typeof _Flex;
